import * as UH from './../util/UrlHttp'
import axios from 'axios'

export const GetGroups = async () => {
    return await axios.get(`${UH.BASE_URL}groups/`, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetGroup = async (id: any) => {
    return await axios.get(`${UH.BASE_URL}groups/${id}`, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export const CreateGroup = async (data: { description: string; members: any[] }) => {
    return await axios.post(`${UH.BASE_URL}groups/`, data, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateGroup = async (id: any, data: { description: string; members: any[] }) => {
    return await axios.post(`${UH.BASE_URL}groups/${id}`, data, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export const DeleteGroup = async (id: any) => {
    return await axios.delete(`${UH.BASE_URL}groups/${id}`, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}
